import React from 'react';
import css from './TestimonialsSlider.module.css';
import Slider from 'react-slick';
import testimonial1 from '../../../../../assets/testimonial-1.png';
import testimonial2 from '../../../../../assets/testimonial-2.png';
import IconCard from '../../../../../components/SavedCardDetails/IconCard/IconCard';
import {FormattedMessage} from '../../../../../util/reactIntl';

const PrevArrow = ({ onClick }) => (
    <button type="button" className={classNames(css.arrow, css.left)} onClick={onClick}>
        <IconCard type="prevArrow" />
    </button>
);

const NextArrow = ({ onClick }) => (
    <button type="button" className={classNames(css.arrow, css.right)} onClick={onClick}>
        <IconCard type="nextArrow" />
    </button>
);

const testimonialList = [
    {
        image: testimonial1,
        testimonialMessage: '“Our daughter now speaks Arabic confidently with her grandparents -- and she loves her lesson!',
        name: 'layla A',
        location: "Dubai",
        backgroundColor: "#EAF0EA"
    },
    {
        image: testimonial2,
        testimonialMessage: '“Arabic made Arabic fun again for our kids. Their tutor is like part of the family.',
        name: 'Omar T',
        location: "Toronto",
        backgroundColor: "#FFF5E2"
    },
    {
        image: testimonial1,
        testimonialMessage: '“Our daughter now speaks Arabic confidently with her grandparents -- and she loves her lesson!',
        name: 'layla A',
        location: "Dubai",
        backgroundColor: "#EAF0EA"
    }
]

function TestimonialsSlider() {
    const sliderRef = React.useRef();

    const settings = {
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerPadding: 20,
        arrows: false,
        responsive: [
            {
                breakpoint: 1320,
                settings: {
                    slidesToShow: 1.5,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.1,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 520,
                settings: {
                    slidesToShow: 1.2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    };

    return (
        <div className={css.testimonialsSlider}>
            <div className={css.testimonialsSliderWrapper}>
                <div className={css.testimonialsTitle}>
                    <FormattedMessage id="TestimonialsSlider.title" />
                </div>
                <div className={css.sliderArrows}>
                    <span type="button" onClick={() => sliderRef.current?.slickPrev()}>
                        <IconCard type="prevArrow" />
                    </span>
                    <span type="button" onClick={() => sliderRef.current?.slickNext()}>
                        <IconCard type="nextArrow" />
                    </span>
                </div>
                <div className={css.testimonialsSliderContent}>
                    <Slider ref={sliderRef} {...settings} className={css.slider}>
                        {testimonialList.map((item, i) => {
                            return (
                                <div key={i} className={css.sliderItem}>
                                    <div className={css.testimonialImage}>
                                        <img src={item.image} alt="testimonial" />
                                    </div>
                                    <div className={css.testimonialContent} style={{ backgroundColor: item.backgroundColor }}>
                                        <div className={css.testimonialMessage}>
                                            {item.testimonialMessage}
                                        </div>
                                        <div className={css.testimonialBottomCard}>
                                            <div>
                                                <div className={css.testimonialName}>
                                                    {item.name}
                                                </div>
                                                <div className={css.testimonialLocation}>
                                                    {item.location}
                                                </div>
                                            </div>
                                            <div className={css.ratingStar}>
                                                <IconCard type="solidStar" />
                                                <IconCard type="solidStar" />
                                                <IconCard type="solidStar" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </Slider>
                </div>
            </div>
        </div>
    )
}

export default TestimonialsSlider